<template>
  <div class="table12">
    <el-table :data="list" height="850" style="width: 100%" ref="table">
      <el-table-column prop="" label="基金">
        <template slot-scope="scope">
          <div style="font-size: 15px; color: #333333">
            {{ scope.row.ths_convertible_debt_short_name_cbond }}
          </div>
          <div style="font-size: 13px; color: #999999">
            {{ scope.row.code }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="that_bond_type" label="类型" align="center">
        <template slot-scope="scope">
          {{scope.row.that_bond_type || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="ths_ipo_plan_issue_total_amt_bond" label="规模" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.ths_ipo_plan_issue_total_amt_bond || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="that_scheme_progress" label="方案进展" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.that_scheme_progress || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="that_listed_issue_date" label="进展公告日" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.that_listed_issue_date || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="shareholder_placement_ratio" label="股东配售率" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.shareholder_placement_ratio || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="that_stock_price_bond_price_ratio" label="正股现价比转股价" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.that_stock_price_bond_price_ratio || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="that_100_stock_have_right" label="百元股票含权(元)" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.that_100_stock_have_right || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="ths_place_amt_ps_cbond" label="每股配售(元)" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.ths_place_amt_ps_cbond || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="number_of_shares_required" label="配售10张所需股数" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.number_of_shares_required || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="ths_old_holder_allot_equity_rd_cbond" label="股权登记日" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.ths_old_holder_allot_equity_rd_cbond || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="ths_bond_latest_credict_rating_bond" label="评级" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.ths_bond_latest_credict_rating_bond || '--'}}
        </template>        
      </el-table-column>
      <el-table-column prop="ths_online_lottery_ratio_cbond" label="中签率" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.ths_online_lottery_ratio_cbond || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="single_account_winning" label="单项户中签(顶格)" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.single_account_winning || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="number_of_subscription_households" label="申购户数(万户)" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.number_of_subscription_households || '--'}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {waitPublishCbondList} from '../../../http/index.js'
export default {
  data() {
    return {
      list:[],
      page:1,
      page_number:20,
      sortObj:{},
    };
  },
    mounted() {
    this.getlist()
    // 获取需要绑定的table
    this.dom = this.$refs.table.bodyWrapper
    this.dom.addEventListener('scroll', () => {
        // 滚动距离
        let scrollTop = this.dom.scrollTop
        let canshu = 350 * this.page
        console.log(canshu);
        console.log(scrollTop);
        if(scrollTop > canshu){
          this.getMore()
        }
    })
  },
  methods:{
    getMore() {
      this.page++
      this.getlist()
    },
    getlist(){
      let obj = this.sortObj
      let params = Object.assign({},{page:this.page,page_number:this.page_number},obj)
      waitPublishCbondList(params).then((res)=>{
        if(this.page == 1){
          this.list = res.data.list
        }else{
          this.list = this.list.concat(res.data.list)
        }
       
      })
    },
    sortChange(a){
      this.page = 1
      this.list = []
      let canshu1 = a.prop
      let canshu2 
      if(a.order == 'ascending'){
        canshu2 = 'asc'
      }else if(a.order == 'descending'){
        canshu2 = 'desc'
      }else{
        canshu2 = null
      }
      if(canshu2 == null){
        this.sortObj = {}
        this.getlist()
      }else{
        let obj = {sort: `${canshu1} ${canshu2}`}
        this.sortObj = obj
        this.getlist()
      }
    }
  }
};
</script>

<style scoped>
.table12 {
  min-width: 1427px;
  position: relative;
}

th img {
  width: 8px;
  height: 15px;
  vertical-align: middle;
  margin-left: 6px;
}
td img {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.ssd {
  background-color: #539cff;
  font-size: 10px;
  height: 13px;
  line-height: 13px;
  border-radius: 3px;
  color: #fefefe;
  padding: 0 5px;
}

i {
  font-style: normal;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.fontSize16 {
  font-size: 16px;
}
.colorRed {
  color: #fd4c4c;
}
.colorBlue {
  color: #4372ba;
}
.colorGreen {
  color: #41b357;
}
.BackColorGreen {
  background-color: #41b357;
}
.BackColorBlue {
  background-color: #4372ba;
}
.table12 /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.table12 /deep/ .cell{
  padding: 0;
}
.table12 /deep/ .el-table th.el-table__cell>.cell{
  padding:  0;
}
</style>